module.exports = __webpack_public_path__ + "img/preview.c8c2179c.svg";